export var envSelector = 'tuscia';
export const appTitle = "GECOWEB"
export const spidBan = true
export const alertEnviroment = "";
export const titleEnviroment = "GeCoWEB Plus";
export const baseUrl = 'https://gecoplus-unitus.lazioinnova.it/service/';
